import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/ui/skeleton';
type PropsType = {
  rows?: number;
};

/**
 * Skeleton placeholder for the products list (controls bar + table). Shared between the route-level
 * loading.tsx (initial SSR navigation) and the client-side products browser (page/sort/size fetches)
 * so both show the exact same loading state.
 */
const ProductsListSkeleton = t0 => {
  const $ = _c(5);
  const {
    rows: t1
  } = t0;
  const rows = t1 === undefined ? 10 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton className="h-4 w-36" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-end justify-between">{t2}<div className="flex items-center gap-3"><div className="flex items-center gap-2"><Skeleton className="h-4 w-28" /><Skeleton className="h-9 w-16 rounded-md" /></div><Skeleton className="h-9 w-32 rounded-md" /></div></div>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="bg-muted flex items-center border-b px-3 py-2.5 text-xs"><div className="w-12 shrink-0" /><Skeleton className="mx-3 h-3 w-28 shrink-0" /><Skeleton className="mx-3 h-3 w-20 shrink-0" /><Skeleton className="mx-3 h-3 w-14 shrink-0" /><Skeleton className="mx-3 h-3 w-16 shrink-0" /><Skeleton className="mx-3 h-3 w-20 shrink-0" /><Skeleton className="ml-auto h-3 w-10 shrink-0" /><div className="ml-3 w-42 shrink-0" /></div>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== rows) {
    t5 = <div className="space-y-4">{t3}<div className="overflow-hidden rounded-lg border">{t4}{Array.from({
          length: rows
        }).map(_temp)}</div></div>;
    $[3] = rows;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
};
export default ProductsListSkeleton;
function _temp(_, i) {
  return <div key={i} className="flex items-center border-b px-3 py-2 last:border-0"><div className="w-22 shrink-0 p-1"><div className="aspect-4/3 w-20 overflow-hidden rounded"><Skeleton className="h-full w-full" /></div></div><div className="mx-3 w-48 shrink-0 space-y-1.5"><Skeleton className="h-3 w-full" /><Skeleton className="h-3 w-2/3" /></div><Skeleton className="mx-3 h-3 w-24 shrink-0" /><Skeleton className="mx-3 h-3 w-36 shrink-0" /><Skeleton className="mx-3 h-3 w-28 shrink-0" /><Skeleton className="mx-3 h-5 w-16 shrink-0 rounded-full" /><Skeleton className="ml-auto h-5 w-16 shrink-0" /><div className="ml-3 flex shrink-0 gap-2"><Skeleton className="h-8 w-32 shrink-0 rounded-md" /><Skeleton className="h-8 w-8 shrink-0 rounded-md" /></div></div>;
}